import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";

function AllLiveAuctionFrame({ children, handleReload, ListLoadings }) {
  const isMobile = useMediaQuery({ query: "(max-width: 560px)" });
  const [currentTime, setCurrentTime] = useState(new Date());
  const { accountType } = useSelector((state) => state.account);

  useEffect(() => {
    const timerId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => {
      clearInterval(timerId);
    };
  }, []);

  return (
    <div
      className={`${accountType === "industry" ? "" : "p-1 white"} `}
      style={{ overflow: "hidden" }}
    >
      <span
        className={`flex  align-center mb-1 ${
          isMobile ? "column" : "space-between"
        }`}
      >
        <h4 className="mb-1">Live Auctions</h4>

        <span className="flex align-center gap-1">
          {accountType !== "industry" && (
            <button
              className="flex align-center reload-btn"
              style={{ backgroundColor: "red" }}
              onClick={() => window.close()}
            >
              <span className="material-symbols-outlined">exit_to_app</span>
            </button>
          )}
          <button
            className="flex align-center reload-btn  "
            onClick={handleReload}
            disabled={ListLoadings}
          >
            <span className="material-symbols-outlined">autorenew</span>
            <p>Reload</p>
          </button>
          <b className="time-update">
            IST Time: {currentTime.toLocaleTimeString()}
          </b>
        </span>
      </span>

      {children}
    </div>
  );
}

export default AllLiveAuctionFrame;
